import { type Odd } from '../types';

export const isOddsActive = (odds: Odd) => {
  return odds.status.toLowerCase() === 'active';
};
